import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ThemePalette } from '@angular/material/core';

@Component({
  standalone: false,
  selector: 'modal-confirmation-component',
  templateUrl: 'modal-confirmation.component.html',
})
export class ModalConfirmationComponent {
  // Only set when `data.prompt` is supplied; the dialog then closes with this text instead of `true`,
  // leaving every existing caller unchanged.
  public promptValue = '';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title?: string;
      content?: string;
      confirmBtnLabel?: string;
      btnColor?: ThemePalette;
      prompt?: { label: string; hint?: string; required?: boolean };
    },
  ) {}

  public get confirmDisabled(): boolean {
    return !!this.data?.prompt?.required && !this.promptValue.trim();
  }

  public get result(): string | boolean {
    return this.data?.prompt ? this.promptValue.trim() : true;
  }
}
